import * as API from './index'

export default {
    import: params => {
        return API.POSTFORM('/api/MatchSchedule/Import', params)
    },
    download: params => {
        return API.GETBlog('/api/MatchSchedule/Export', params)
    }, getList: params => {
        return API.GET('/api/MatchSchedule/List', params)
    },
    delete: params => {
        return API.DELETE('/api/MatchSchedule/delete', params)
    },
    deleteMatch: params => {
        return API.DELETE('/api/MatchSchedule/deleteMatch', params)
    },
    deleteBatch: params => {
        return API.DELETEBATCH('/api/MatchSchedule/DeleteBatch', params)
    }
}


// WEBPACK FOOTER //
// ./src/apis/matchschedule.js